<div>
  <button mat-mini-fab class="edit-credit-button" (click)="openAssignmentsModal()"><i class="material-icons" style="font-size:16px">edit</i></button>
</div>
@for (credit of creditOutlets; track credit) {
  <div>
    <div class="row align-top gutters">
      <div class="col-md-12">
        <div class="fund-header">
          <mat-icon>account_balance</mat-icon>
          <span class="fund-name"><a href="{{credit.url}}">{{credit.name}}</a></span>
          @if (credit.fundType) {
            <span class="fund-type">{{credit.fundType}}</span>
          }
          @if (!credit.fundType) {
            <span class="fund-type">Certificated Outlet</span>
          }
        </div>
        <div class="fund-info">
          @if (credit.fundStatus) {
            <span class="fund-field">
              <b>Status: </b>{{credit.fundStatus}}
            </span>
          }
          @if (credit.closingDate) {
            <span class="fund-field">
              <b>Closing Date: </b>{{credit.closingDate}}
            </span>
          }
        </div>
      </div>
    </div>
    <div class="row align-top gutters bottom-space">
      <div class="col-md-4">
        <div class="subsection-header orange">Fund Participants</div>
        @if (credit.participants && credit.participants.length > 0) {
          <deal-fund-participants-table [participants]="credit.participants"></deal-fund-participants-table>
        }
        @if (!credit.participants || credit.participants.length <= 0) {
          <div>
            <em>There are no participants for this fund.</em>
          </div>
        }
      </div>
      @for (outlet of credit.outlets; track outlet) {
        <div class="col-md-4">
          <div class="subsection-header" [ngClass]="outlet.projectCredit.includes('Federal') ? 'teal' : 'purple'">{{outlet.projectCredit}}</div>
          <deal-credit-outlets-table [outlets]="outlet.table" [isCalculated]="outlet.useGrossEquityCalc"></deal-credit-outlets-table>
        </div>
      }
    </div>
  </div>
}

@if (!creditOutlets || creditOutlets.length <= 0) {
  <div class="row align-top gutters">
    <div class="col-md-12">
      <em>There are no Credit Outlets assigned to this deal.</em>
    </div>
  </div>
}
